import { render, staticRenderFns } from "./BlockButton.vue?vue&type=template&id=1668edae&scoped=true"
import script from "./BlockButton.vue?vue&type=script&lang=js"
export * from "./BlockButton.vue?vue&type=script&lang=js"
import style0 from "./BlockButton.vue?vue&type=style&index=0&id=1668edae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668edae",
  null
  
)

export default component.exports